import { render } from "./DetailEdgeDeviceView.vue?vue&type=template&id=63da48ca&scoped=true"
import script from "./DetailEdgeDeviceView.vue?vue&type=script&lang=js"
export * from "./DetailEdgeDeviceView.vue?vue&type=script&lang=js"

import "./DetailEdgeDeviceView.vue?vue&type=style&index=0&id=63da48ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63da48ca"]])

export default __exports__